import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { formValueSelector } from 'redux-form';
import styled from 'styled-components';
import moment from 'moment';
import { Header, Filter, ImagePreview, BidStatus } from './components';
import { Table, Timer, NoImagePlaceholder } from '../../../components';
import { VEHICLE_STATUSES, BIDS_PER_PAGE, DATE_FORMAT } from '../../../constants';
import { MobileInfo } from './components/MobileInfo';
import { Delimiter } from 'components/Table/common';
import { VehicleOptionsBlock } from '../VehicleSales/components/tableBlocks';
import { ButtonsBlock } from './components/ButtonsBlock';
import { useGetSellerManageVehiclesQuery } from 'services/api/manage-vehicles';
import { useWindowSize } from 'usehooks-ts';
import { setPage, setFilters as setReduxFilters } from 'services/sellerVehicles/sellerVehiclesSlice';
import { MobileActionButtons } from './components/MobileActionButtons';
import { VehicleListContext } from '../../Admin/VehiclesList/context';
import { VehiclesListComponent } from '../../Admin/VehiclesList/list';
import { store } from '../../../store/configureStore';

const StyledTableWrapper = styled.div`
  tr td:first-child {
    width: 80px;
  }

  @media (min-width: 800px) {
    tr td:last-child {
      width: 160px;
    }
  }

  @media (max-width: 800px) {
    thead tr {
      height: 0px;
    }
  }
`;

const VehicleListProvider = () => {
  const { page, perPage, filters } = useSelector(state => state.sellerVehicles);
  const { data, isFetching, refetch } = useGetSellerManageVehiclesQuery({
    limit: perPage,
    offset: page,
    ...filters
  });

  const dispatch = useDispatch();

  const vehicles = useMemo(() => data?.rows?.ids?.map(id => data?.rows?.entities?.[id]) ?? [], [data]);
  const vehiclesCount = useMemo(() => Number(data?.count ?? 0), [data]);

  const loadMore = () => {
    if (page * perPage > vehiclesCount) return;
    dispatch(setPage(page + 1));
  };

  const getFilters = () => store.getState().sellerVehicles.filters;
  const setFilters = newFilters => dispatch(setReduxFilters(newFilters));

  const refreshQuery = () => {
    if (page === 1) {
      refetch();
    } else {
      setFilters({});
    }
  };

  return (
    <VehicleListContext.Provider
      value={{
        vehicles,
        vehiclesCount,
        isFetching,
        loadMore,
        getFilters,
        setFilters,
        refreshQuery
      }}
    >
      <VehiclesListComponent />
    </VehicleListContext.Provider>
  );
};

export default VehicleListProvider;
